import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DocumentInput, User, WhatsappTemplateEnum } from '@app/models';

interface WhatsappTemplateContent {
  header: string;
  body: string;
  documentLine: string;
  senderLine: string;
  footer: string;
  buttonText: string;
}

@Component({
  selector: 'app-signature-whatsapp-preview',
  templateUrl: './signature-whatsapp-preview.component.html',
  styleUrls: ['./signature-whatsapp-preview.component.scss'],
  standalone: false
})
export class SignatureWhatsappPreviewComponent implements OnInit {
  @Input() user: User;
  @Input() document: DocumentInput;
  @Input() whatsappType: WhatsappTemplateEnum;
  @Input() selectedLang: string;

  currentDate: Date = new Date();

  constructor(private translateService: TranslateService) {}

  ngOnInit() {
    this.document.whatsapp_template = this.document.whatsapp_template || WhatsappTemplateEnum.Standard;
  }

  get whatsappTemplateContent(): WhatsappTemplateContent {
    const templateKey = this.getTemplateKey(this.whatsappType);
    const companyName = this.user?.member?.group?.styles?.overwrite_name ? this.user?.member?.group?.company : this.user?.company || this.user.name;

    const interpolationParams = {
      companyName: companyName,
      documentName: this.document.name,
      senderName: this.user.name
    };

    return {
      header: this.translateService.instant(`whatsappTemplates.${templateKey}.header`, interpolationParams),
      body: this.translateService.instant(`whatsappTemplates.${templateKey}.body`, interpolationParams),
      documentLine: this.translateService.instant(`whatsappTemplates.${templateKey}.documentLine`, interpolationParams),
      senderLine: this.translateService.instant(`whatsappTemplates.${templateKey}.senderLine`, interpolationParams),
      footer: this.translateService.instant(`whatsappTemplates.${templateKey}.footer`, interpolationParams),
      buttonText: this.translateService.instant(`whatsappTemplates.${templateKey}.buttonText`, interpolationParams)
    };
  }

  private getTemplateKey(templateType: WhatsappTemplateEnum): string {
    switch (templateType) {
      case WhatsappTemplateEnum.Standard:
        return 'standard';
      case WhatsappTemplateEnum.Formal:
        return 'formal';
      case WhatsappTemplateEnum.Casual:
        return 'casual';
      case WhatsappTemplateEnum.Direct:
        return 'direct';
      default:
        return 'standard';
    }
  }
}
